import {ReactElement, ReactNode} from 'react';
import {
  AlertTemplateProps,
  positions,
  Provider,
  transitions,
} from 'react-alert';
import {Image} from '@shopify/hydrogen';

const options = {
  position: positions.BOTTOM_CENTER,
  timeout: 5000,
  offset: '0.5rem',
  transition: transitions.SCALE,
  containerStyle: {
    zIndex: 9999,
  },
};

interface AlertProps {
  children?: ReactNode;
}

export function AlertProvider({children}: AlertProps): ReactElement {
  return (
    <Provider template={AlertTemplate} {...options}>
      {children}
    </Provider>
  );
}

function SuccessIcon({stroke = '#FFFFFF'}: {stroke?: string}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 11.0799V11.9999C21.9988 14.1563 21.3005 16.2545 20.0093 17.9817C18.7182 19.7088 16.9033 20.9723 14.8354 21.5838C12.7674 22.1952 10.5573 22.1218 8.53447 21.3744C6.51168 20.6271 4.78465 19.246 3.61096 17.4369C2.43727 15.6279 1.87979 13.4879 2.02168 11.3362C2.16356 9.18443 2.99721 7.13619 4.39828 5.49694C5.79935 3.85768 7.69279 2.71525 9.79619 2.24001C11.8996 1.76477 14.1003 1.9822 16.07 2.85986"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 4L12 14.01L9 11.01"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CloseIcon({stroke = '#FFFFFF'}: {stroke?: string}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AlertTemplate({
  style,
  options,
  message,
  close,
}: AlertTemplateProps): ReactElement {
  let icon: ReactNode = undefined;
  let background: string | undefined = undefined;
  let color: string | undefined = undefined;
  switch (options.type) {
    case 'info':
      // icon = <SuccessIcon />;
      background = '#593B37';
      color = '#FFFFFF';
      break;
    case 'success':
      icon = <SuccessIcon />;
      background = '#593B37';
      color = '#FFFFFF';
      break;
    case 'error':
      // icon = <SuccessIcon />;
      background = '#593B37';
      color = '#FFFFFF';
      break;

    default:
      break;
  }
  return (
    <div
      style={{
        ...style,
        background,
        color,
        backdropFilter: 'blur(80px)',
      }}
      className={'flex items-center gap-x-4 p-4 drop-shadow-lg'}
    >
      {icon && (
        <div className="flex" style={{color}}>
          {icon}
        </div>
      )}
      <div className="flex items-center" style={{color}}>
        {message}
      </div>
      <button
        onClick={close}
        className="text-sm font-bold text-white"
        style={{color}}
      >
        <CloseIcon />
      </button>
    </div>
  );
}
